import script from "./TicketNumberCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketNumberCell.vue?vue&type=script&setup=true&lang=js"

import "./TicketNumberCell.vue?vue&type=style&index=0&id=42a27550&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a27550"]])

export default __exports__